import { setCookie, getCookie } from '@/util/cookies'
import axios from "axios";
import {supportedLanguages} from "@/config";

const setPreferredLanguageFromCookie = (locale) => {
    setCookie('locale', locale)
    axios.defaults.headers.common['Accept-Language'] = locale
}

const getPreferredLanguageFromCookie = () => {
    const locale = getCookie('locale')
    const defaultLanguage = process.env.VUE_APP_DEFAULT_LANGUAGE
    if (!locale || locale === "") {
        setCookie('locale', defaultLanguage)

        return defaultLanguage
    }
    return locale;
}

const getLocales = () => {
    const languages = [
        {
            name: 'عربي',
            attr: 'ar'
        },
        {
            name: 'English',
            attr: 'en'
        },
        {
            name: 'Français',
            attr: 'fr'
        }
    ]

    return languages.filter(lang => supportedLanguages.includes(lang.attr))
}

export {
    setPreferredLanguageFromCookie,
    getPreferredLanguageFromCookie,
    getLocales,
}
